import { getTestId } from '@airtel/air-design-system';
var cardSliderBreakPoint = {
  xs: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  sm: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  md: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  lg: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  xl: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  }
};
var carouselProps = {
  data: Array.from({
    length: 4
  }, () => ({
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    onPress: {
      from: 'child'
    }
  })),
  carouselType: 'IMAGE',
  breakPoints: cardSliderBreakPoint,
  theme: 'light',
  heightConfig: {
    desktop: 380,
    mobile: 375
  },
  onLeftNavigationPress: {},
  onRightNavigationPress: {},
  isPressable: true,
  showNavigationCtas: true,
  onPress: {
    from: 'parent'
  },
  onUserAction: function onUserAction() {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }
    console.log(JSON.stringify(data));
  }
};
var planDetailsProps = {
  planDetailTitle: 'PLAN DETAILS',
  infoTagText: 'offer',
  planInfoData: {
    planName: 'Infinity Family 399 plan',
    amount: '₹399',
    subText: 'GST will be calculated at checkout',
    alignment: 'left'
  },
  ctaText: 'Buy Now',
  benefitData: [{
    icon: 'DataTopupIcon',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: 'data',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'ChatSupportButtonIcon',
    data: {
      multiText: [{
        text: '100 SMS ',
        type: 'body-para-sm-bold'
      }, {
        text: 'per day',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'CallIcon',
    data: {
      multiText: [{
        text: 'unlimited calls ',
        type: 'body-para-sm-bold'
      }, {
        text: '(local & STD roaming)',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music ',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: '1 ',
        type: 'body-para-sm-bold'
      }, {
        text: 'SIM',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'DataTopupIcon',
    data: {
      multiText: [{
        text: '40 GB ',
        type: 'body-para-sm-bold'
      }, {
        text: ' data',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'ChatSupportButtonIcon',
    data: {
      multiText: [{
        text: '100 SMS ',
        type: 'body-para-sm-bold'
      }, {
        text: 'per day',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'CallIcon',
    data: {
      multiText: [{
        text: 'unlimited calls ',
        type: 'body-para-sm-bold'
      }, {
        text: '(local & STD roaming)',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music',
        type: 'body-para-sm-bold'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music 11',
        type: 'body-para-sm'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }, {
    icon: 'SimIcon',
    data: {
      multiText: [{
        text: 'Wynk Music 11',
        type: 'body-para-sm'
      }, {
        text: '· 1 year',
        type: 'body-para-sm'
      }]
    }
  }],
  viewAllCtaProps: {
    text: 'view all'
  }
};
export var defaultProps = Object.assign({
  carouselProps,
  planDetailsProps
}, getTestId('full-plan-detail-widget'));